export default {
      id: "ic-plan-eau-usage",
      viewBox: "0 0 40 40",
      url: "../../../plugins/creasit-builder/assets/dist/images/" + "sprite.svg#ic-plan-eau-usage",
      toString: function () {
        return this.url;
      }
    }